// Copyright 2014 Google Inc. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
//     You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//     See the License for the specific language governing permissions and
// limitations under the License.
!function() {
    var a1 = {}, b = {}, c = {};
    !function(a1, b) {
        function c(a1) {
            if ("number" == typeof a1) return a1;
            var b = {};
            for(var c in a1)b[c] = a1[c];
            return b;
        }
        function d() {
            this._delay = 0, this._endDelay = 0, this._fill = "none", this._iterationStart = 0, this._iterations = 1, this._duration = 0, this._playbackRate = 1, this._direction = "normal", this._easing = "linear", this._easingFunction = x;
        }
        function e() {
            return a1.isDeprecated("Invalid timing inputs", "2016-03-02", "TypeError exceptions will be thrown instead.", !0);
        }
        function f(b, c, e) {
            var f = new d;
            return c && (f.fill = "both", f.duration = "auto"), "number" != typeof b || isNaN(b) ? void 0 !== b && Object.getOwnPropertyNames(b).forEach(function(c) {
                if ("auto" != b[c]) {
                    if (("number" == typeof f[c] || "duration" == c) && ("number" != typeof b[c] || isNaN(b[c]))) return;
                    if ("fill" == c && -1 == v.indexOf(b[c])) return;
                    if ("direction" == c && -1 == w.indexOf(b[c])) return;
                    if ("playbackRate" == c && 1 !== b[c] && a1.isDeprecated("AnimationEffectTiming.playbackRate", "2014-11-28", "Use Animation.playbackRate instead.")) return;
                    f[c] = b[c];
                }
            }) : f.duration = b, f;
        }
        function g(a1) {
            return "number" == typeof a1 && (a1 = isNaN(a1) ? {
                duration: 0
            } : {
                duration: a1
            }), a1;
        }
        function h(b, c) {
            return b = a1.numericTimingToObject(b), f(b, c);
        }
        function i(a1, b, c, d) {
            return a1 < 0 || a1 > 1 || c < 0 || c > 1 ? x : function(e) {
                function f(a1, b, c) {
                    return 3 * a1 * (1 - c) * (1 - c) * c + 3 * b * (1 - c) * c * c + c * c * c;
                }
                if (e <= 0) {
                    var g = 0;
                    return a1 > 0 ? g = b / a1 : !b && c > 0 && (g = d / c), g * e;
                }
                if (e >= 1) {
                    var h = 0;
                    return c < 1 ? h = (d - 1) / (c - 1) : 1 == c && a1 < 1 && (h = (b - 1) / (a1 - 1)), 1 + h * (e - 1);
                }
                for(var i = 0, j = 1; i < j;){
                    var k = (i + j) / 2, l = f(a1, c, k);
                    if (Math.abs(e - l) < 1e-5) return f(b, d, k);
                    l < e ? i = k : j = k;
                }
                return f(b, d, k);
            };
        }
        function j(a1, b) {
            return function(c) {
                if (c >= 1) return 1;
                var d = 1 / a1;
                return (c += b * d) - c % d;
            };
        }
        function k(a1) {
            C || (C = document.createElement("div").style), C.animationTimingFunction = "", C.animationTimingFunction = a1;
            var b = C.animationTimingFunction;
            if ("" == b && e()) throw new TypeError(a1 + " is not a valid value for easing");
            return b;
        }
        function l(a1) {
            if ("linear" == a1) return x;
            var b = E.exec(a1);
            if (b) return i.apply(this, b.slice(1).map(Number));
            var c = F.exec(a1);
            if (c) return j(Number(c[1]), A);
            var d = G.exec(a1);
            return d ? j(Number(d[1]), {
                start: y,
                middle: z,
                end: A
            }[d[2]]) : B[a1] || x;
        }
        function m(a1) {
            return Math.abs(n(a1) / a1.playbackRate);
        }
        function n(a1) {
            return 0 === a1.duration || 0 === a1.iterations ? 0 : a1.duration * a1.iterations;
        }
        function o(a1, b, c) {
            if (null == b) return H;
            var d = c.delay + a1 + c.endDelay;
            return b < Math.min(c.delay, d) ? I : b >= Math.min(c.delay + a1, d) ? J : K;
        }
        function p(a1, b, c, d, e) {
            switch(d){
                case I:
                    return "backwards" == b || "both" == b ? 0 : null;
                case K:
                    return c - e;
                case J:
                    return "forwards" == b || "both" == b ? a1 : null;
                case H:
                    return null;
            }
        }
        function q(a1, b, c, d, e) {
            var f = e;
            return 0 === a1 ? b !== I && (f += c) : f += d / a1, f;
        }
        function r(a1, b, c, d, e, f) {
            var g = a1 === 1 / 0 ? b % 1 : a1 % 1;
            return 0 !== g || c !== J || 0 === d || 0 === e && 0 !== f || (g = 1), g;
        }
        function s(a1, b, c, d) {
            return a1 === J && b === 1 / 0 ? 1 / 0 : 1 === c ? Math.floor(d) - 1 : Math.floor(d);
        }
        function t(a1, b, c) {
            var d = a1;
            if ("normal" !== a1 && "reverse" !== a1) {
                var e = b;
                "alternate-reverse" === a1 && (e += 1), d = "normal", e !== 1 / 0 && e % 2 != 0 && (d = "reverse");
            }
            return "normal" === d ? c : 1 - c;
        }
        function u(a1, b, c) {
            var d = o(a1, b, c), e = p(a1, c.fill, b, d, c.delay);
            if (null === e) return null;
            var f = q(c.duration, d, c.iterations, e, c.iterationStart), g = r(f, c.iterationStart, d, c.iterations, e, c.duration), h = s(d, c.iterations, g, f), i = t(c.direction, h, g);
            return c._easingFunction(i);
        }
        var v = "backwards|forwards|both|none".split("|"), w = "reverse|alternate|alternate-reverse".split("|"), x = function(a1) {
            return a1;
        };
        d.prototype = {
            _setMember: function(b, c) {
                this["_" + b] = c, this._effect && (this._effect._timingInput[b] = c, this._effect._timing = a1.normalizeTimingInput(this._effect._timingInput), this._effect.activeDuration = a1.calculateActiveDuration(this._effect._timing), this._effect._animation && this._effect._animation._rebuildUnderlyingAnimation());
            },
            get playbackRate () {
                return this._playbackRate;
            },
            set delay (a){
                this._setMember("delay", a);
            },
            get delay () {
                return this._delay;
            },
            set endDelay (a){
                this._setMember("endDelay", a);
            },
            get endDelay () {
                return this._endDelay;
            },
            set fill (a){
                this._setMember("fill", a);
            },
            get fill () {
                return this._fill;
            },
            set iterationStart (a){
                if ((isNaN(a) || a < 0) && e()) throw new TypeError("iterationStart must be a non-negative number, received: " + a);
                this._setMember("iterationStart", a);
            },
            get iterationStart () {
                return this._iterationStart;
            },
            set duration (a){
                if ("auto" != a && (isNaN(a) || a < 0) && e()) throw new TypeError("duration must be non-negative or auto, received: " + a);
                this._setMember("duration", a);
            },
            get duration () {
                return this._duration;
            },
            set direction (a){
                this._setMember("direction", a);
            },
            get direction () {
                return this._direction;
            },
            set easing (a){
                this._easingFunction = l(k(a)), this._setMember("easing", a);
            },
            get easing () {
                return this._easing;
            },
            set iterations (a){
                if ((isNaN(a) || a < 0) && e()) throw new TypeError("iterations must be non-negative, received: " + a);
                this._setMember("iterations", a);
            },
            get iterations () {
                return this._iterations;
            }
        };
        var y = 1, z = .5, A = 0, B = {
            ease: i(.25, .1, .25, 1),
            "ease-in": i(.42, 0, 1, 1),
            "ease-out": i(0, 0, .58, 1),
            "ease-in-out": i(.42, 0, .58, 1),
            "step-start": j(1, y),
            "step-middle": j(1, z),
            "step-end": j(1, A)
        }, C = null, D = "\\s*(-?\\d+\\.?\\d*|-?\\.\\d+)\\s*", E = new RegExp("cubic-bezier\\(" + D + "," + D + "," + D + "," + D + "\\)"), F = /steps\(\s*(\d+)\s*\)/, G = /steps\(\s*(\d+)\s*,\s*(start|middle|end)\s*\)/, H = 0, I = 1, J = 2, K = 3;
        a1.cloneTimingInput = c, a1.makeTiming = f, a1.numericTimingToObject = g, a1.normalizeTimingInput = h, a1.calculateActiveDuration = m, a1.calculateIterationProgress = u, a1.calculatePhase = o, a1.normalizeEasing = k, a1.parseEasingFunction = l;
    }(a1), function(a1, b) {
        function c(a1, b) {
            return a1 in k ? k[a1][b] || b : b;
        }
        function d(a1) {
            return "display" === a1 || 0 === a1.lastIndexOf("animation", 0) || 0 === a1.lastIndexOf("transition", 0);
        }
        function e(a1, b, e) {
            if (!d(a1)) {
                var f = h[a1];
                if (f) {
                    i.style[a1] = b;
                    for(var g in f){
                        var j = f[g], k = i.style[j];
                        e[j] = c(j, k);
                    }
                } else e[a1] = c(a1, b);
            }
        }
        function f(a1) {
            var b = [];
            for(var c in a1)if (!(c in [
                "easing",
                "offset",
                "composite"
            ])) {
                var d = a1[c];
                Array.isArray(d) || (d = [
                    d
                ]);
                for(var e, f = d.length, g = 0; g < f; g++)e = {}, e.offset = "offset" in a1 ? a1.offset : 1 == f ? 1 : g / (f - 1), "easing" in a1 && (e.easing = a1.easing), "composite" in a1 && (e.composite = a1.composite), e[c] = d[g], b.push(e);
            }
            return b.sort(function(a1, b) {
                return a1.offset - b.offset;
            }), b;
        }
        function g(b) {
            function c() {
                var a1 = d.length;
                null == d[a1 - 1].offset && (d[a1 - 1].offset = 1), a1 > 1 && null == d[0].offset && (d[0].offset = 0);
                for(var b = 0, c = d[0].offset, e = 1; e < a1; e++){
                    var f = d[e].offset;
                    if (null != f) {
                        for(var g = 1; g < e - b; g++)d[b + g].offset = c + (f - c) * g / (e - b);
                        b = e, c = f;
                    }
                }
            }
            if (null == b) return [];
            window.Symbol && Symbol.iterator && Array.prototype.from && b[Symbol.iterator] && (b = Array.from(b)), Array.isArray(b) || (b = f(b));
            for(var d = b.map(function(b) {
                var c = {};
                for(var d in b){
                    var f = b[d];
                    if ("offset" == d) {
                        if (null != f) {
                            if (f = Number(f), !isFinite(f)) throw new TypeError("Keyframe offsets must be numbers.");
                            if (f < 0 || f > 1) throw new TypeError("Keyframe offsets must be between 0 and 1.");
                        }
                    } else if ("composite" == d) {
                        if ("add" == f || "accumulate" == f) throw {
                            type: DOMException.NOT_SUPPORTED_ERR,
                            name: "NotSupportedError",
                            message: "add compositing is not supported"
                        };
                        if ("replace" != f) throw new TypeError("Invalid composite mode " + f + ".");
                    } else f = "easing" == d ? a1.normalizeEasing(f) : "" + f;
                    e(d, f, c);
                }
                return void 0 == c.offset && (c.offset = null), void 0 == c.easing && (c.easing = "linear"), c;
            }), g = !0, h = -1 / 0, i = 0; i < d.length; i++){
                var j = d[i].offset;
                if (null != j) {
                    if (j < h) throw new TypeError("Keyframes are not loosely sorted by offset. Sort or specify offsets.");
                    h = j;
                } else g = !1;
            }
            return d = d.filter(function(a1) {
                return a1.offset >= 0 && a1.offset <= 1;
            }), g || c(), d;
        }
        var h = {
            background: [
                "backgroundImage",
                "backgroundPosition",
                "backgroundSize",
                "backgroundRepeat",
                "backgroundAttachment",
                "backgroundOrigin",
                "backgroundClip",
                "backgroundColor"
            ],
            border: [
                "borderTopColor",
                "borderTopStyle",
                "borderTopWidth",
                "borderRightColor",
                "borderRightStyle",
                "borderRightWidth",
                "borderBottomColor",
                "borderBottomStyle",
                "borderBottomWidth",
                "borderLeftColor",
                "borderLeftStyle",
                "borderLeftWidth"
            ],
            borderBottom: [
                "borderBottomWidth",
                "borderBottomStyle",
                "borderBottomColor"
            ],
            borderColor: [
                "borderTopColor",
                "borderRightColor",
                "borderBottomColor",
                "borderLeftColor"
            ],
            borderLeft: [
                "borderLeftWidth",
                "borderLeftStyle",
                "borderLeftColor"
            ],
            borderRadius: [
                "borderTopLeftRadius",
                "borderTopRightRadius",
                "borderBottomRightRadius",
                "borderBottomLeftRadius"
            ],
            borderRight: [
                "borderRightWidth",
                "borderRightStyle",
                "borderRightColor"
            ],
            borderTop: [
                "borderTopWidth",
                "borderTopStyle",
                "borderTopColor"
            ],
            borderWidth: [
                "borderTopWidth",
                "borderRightWidth",
                "borderBottomWidth",
                "borderLeftWidth"
            ],
            flex: [
                "flexGrow",
                "flexShrink",
                "flexBasis"
            ],
            font: [
                "fontFamily",
                "fontSize",
                "fontStyle",
                "fontVariant",
                "fontWeight",
                "lineHeight"
            ],
            margin: [
                "marginTop",
                "marginRight",
                "marginBottom",
                "marginLeft"
            ],
            outline: [
                "outlineColor",
                "outlineStyle",
                "outlineWidth"
            ],
            padding: [
                "paddingTop",
                "paddingRight",
                "paddingBottom",
                "paddingLeft"
            ]
        }, i = document.createElementNS("http://www.w3.org/1999/xhtml", "div"), j = {
            thin: "1px",
            medium: "3px",
            thick: "5px"
        }, k = {
            borderBottomWidth: j,
            borderLeftWidth: j,
            borderRightWidth: j,
            borderTopWidth: j,
            fontSize: {
                "xx-small": "60%",
                "x-small": "75%",
                small: "89%",
                medium: "100%",
                large: "120%",
                "x-large": "150%",
                "xx-large": "200%"
            },
            fontWeight: {
                normal: "400",
                bold: "700"
            },
            outlineWidth: j,
            textShadow: {
                none: "0px 0px 0px transparent"
            },
            boxShadow: {
                none: "0px 0px 0px 0px transparent"
            }
        };
        a1.convertToArrayForm = f, a1.normalizeKeyframes = g;
    }(a1), function(a1) {
        var b = {};
        a1.isDeprecated = function(a1, c, d, e) {
            var f = e ? "are" : "is", g = new Date, h = new Date(c);
            return h.setMonth(h.getMonth() + 3), !(g < h && (a1 in b || console.warn("Web Animations: " + a1 + " " + f + " deprecated and will stop working on " + h.toDateString() + ". " + d), b[a1] = !0, 1));
        }, a1.deprecated = function(b, c, d, e) {
            var f = e ? "are" : "is";
            if (a1.isDeprecated(b, c, d, e)) throw new Error(b + " " + f + " no longer supported. " + d);
        };
    }(a1), function() {
        if (document.documentElement.animate) {
            var c = document.documentElement.animate([], 0), d = !0;
            if (c && (d = !1, "play|currentTime|pause|reverse|playbackRate|cancel|finish|startTime|playState".split("|").forEach(function(a1) {
                void 0 === c[a1] && (d = !0);
            })), !d) return;
        }
        !function(a1, b, c) {
            function d(a1) {
                for(var b = {}, c = 0; c < a1.length; c++)for(var d in a1[c])if ("offset" != d && "easing" != d && "composite" != d) {
                    var e = {
                        offset: a1[c].offset,
                        easing: a1[c].easing,
                        value: a1[c][d]
                    };
                    b[d] = b[d] || [], b[d].push(e);
                }
                for(var f in b){
                    var g = b[f];
                    if (0 != g[0].offset || 1 != g[g.length - 1].offset) throw {
                        type: DOMException.NOT_SUPPORTED_ERR,
                        name: "NotSupportedError",
                        message: "Partial keyframes are not supported"
                    };
                }
                return b;
            }
            function e(c) {
                var d = [];
                for(var e in c)for(var f = c[e], g = 0; g < f.length - 1; g++){
                    var h = g, i = g + 1, j = f[h].offset, k = f[i].offset, l = j, m = k;
                    0 == g && (l = -1 / 0, 0 == k && (i = h)), g == f.length - 2 && (m = 1 / 0, 1 == j && (h = i)), d.push({
                        applyFrom: l,
                        applyTo: m,
                        startOffset: f[h].offset,
                        endOffset: f[i].offset,
                        easingFunction: a1.parseEasingFunction(f[h].easing),
                        property: e,
                        interpolation: b.propertyInterpolation(e, f[h].value, f[i].value)
                    });
                }
                return d.sort(function(a1, b) {
                    return a1.startOffset - b.startOffset;
                }), d;
            }
            b.convertEffectInput = function(c) {
                var f = a1.normalizeKeyframes(c), g = d(f), h = e(g);
                return function(a1, c) {
                    if (null != c) h.filter(function(a1) {
                        return c >= a1.applyFrom && c < a1.applyTo;
                    }).forEach(function(d) {
                        var e = c - d.startOffset, f = d.endOffset - d.startOffset, g = 0 == f ? 0 : d.easingFunction(e / f);
                        b.apply(a1, d.property, d.interpolation(g));
                    });
                    else for(var d in g)"offset" != d && "easing" != d && "composite" != d && b.clear(a1, d);
                };
            };
        }(a1, b), function(a1, b, c) {
            function d(a1) {
                return a1.replace(/-(.)/g, function(a1, b) {
                    return b.toUpperCase();
                });
            }
            function e(a1, b, c) {
                h[c] = h[c] || [], h[c].push([
                    a1,
                    b
                ]);
            }
            function f(a1, b, c) {
                for(var f = 0; f < c.length; f++)e(a1, b, d(c[f]));
            }
            function g(c, e, f) {
                var g = c;
                /-/.test(c) && !a1.isDeprecated("Hyphenated property names", "2016-03-22", "Use camelCase instead.", !0) && (g = d(c)), "initial" != e && "initial" != f || ("initial" == e && (e = i[g]), "initial" == f && (f = i[g]));
                for(var j = e == f ? [] : h[g], k = 0; j && k < j.length; k++){
                    var l = j[k][0](e), m = j[k][0](f);
                    if (void 0 !== l && void 0 !== m) {
                        var n = j[k][1](l, m);
                        if (n) {
                            var o = b.Interpolation.apply(null, n);
                            return function(a1) {
                                return 0 == a1 ? e : 1 == a1 ? f : o(a1);
                            };
                        }
                    }
                }
                return b.Interpolation(!1, !0, function(a1) {
                    return a1 ? f : e;
                });
            }
            var h = {};
            b.addPropertiesHandler = f;
            var i = {
                backgroundColor: "transparent",
                backgroundPosition: "0% 0%",
                borderBottomColor: "currentColor",
                borderBottomLeftRadius: "0px",
                borderBottomRightRadius: "0px",
                borderBottomWidth: "3px",
                borderLeftColor: "currentColor",
                borderLeftWidth: "3px",
                borderRightColor: "currentColor",
                borderRightWidth: "3px",
                borderSpacing: "2px",
                borderTopColor: "currentColor",
                borderTopLeftRadius: "0px",
                borderTopRightRadius: "0px",
                borderTopWidth: "3px",
                bottom: "auto",
                clip: "rect(0px, 0px, 0px, 0px)",
                color: "black",
                fontSize: "100%",
                fontWeight: "400",
                height: "auto",
                left: "auto",
                letterSpacing: "normal",
                lineHeight: "120%",
                marginBottom: "0px",
                marginLeft: "0px",
                marginRight: "0px",
                marginTop: "0px",
                maxHeight: "none",
                maxWidth: "none",
                minHeight: "0px",
                minWidth: "0px",
                opacity: "1.0",
                outlineColor: "invert",
                outlineOffset: "0px",
                outlineWidth: "3px",
                paddingBottom: "0px",
                paddingLeft: "0px",
                paddingRight: "0px",
                paddingTop: "0px",
                right: "auto",
                strokeDasharray: "none",
                strokeDashoffset: "0px",
                textIndent: "0px",
                textShadow: "0px 0px 0px transparent",
                top: "auto",
                transform: "",
                verticalAlign: "0px",
                visibility: "visible",
                width: "auto",
                wordSpacing: "normal",
                zIndex: "auto"
            };
            b.propertyInterpolation = g;
        }(a1, b), function(a1, b, c) {
            function d(b) {
                var c = a1.calculateActiveDuration(b), d = function(d) {
                    return a1.calculateIterationProgress(c, d, b);
                };
                return d._totalDuration = b.delay + c + b.endDelay, d;
            }
            b.KeyframeEffect = function(c, e, f, g) {
                var h, i = d(a1.normalizeTimingInput(f)), j = b.convertEffectInput(e), k = function() {
                    j(c, h);
                };
                return k._update = function(a1) {
                    return null !== (h = i(a1));
                }, k._clear = function() {
                    j(c, null);
                }, k._hasSameTarget = function(a1) {
                    return c === a1;
                }, k._target = c, k._totalDuration = i._totalDuration, k._id = g, k;
            };
        }(a1, b), function(a1, b) {
            a1.apply = function(b, c, d) {
                b.style[a1.propertyName(c)] = d;
            }, a1.clear = function(b, c) {
                b.style[a1.propertyName(c)] = "";
            };
        }(b), function(a1) {
            window.Element.prototype.animate = function(b, c) {
                var d = "";
                return c && c.id && (d = c.id), a1.timeline._play(a1.KeyframeEffect(this, b, c, d));
            };
        }(b), function(a1, b) {
            function c(a1, b, d) {
                if ("number" == typeof a1 && "number" == typeof b) return a1 * (1 - d) + b * d;
                if ("boolean" == typeof a1 && "boolean" == typeof b) return d < .5 ? a1 : b;
                if (a1.length == b.length) {
                    for(var e = [], f = 0; f < a1.length; f++)e.push(c(a1[f], b[f], d));
                    return e;
                }
                throw "Mismatched interpolation arguments " + a1 + ":" + b;
            }
            a1.Interpolation = function(a1, b, d) {
                return function(e) {
                    return d(c(a1, b, e));
                };
            };
        }(b), function(a1, b, c) {
            a1.sequenceNumber = 0;
            var d = function(a1, b, c) {
                this.target = a1, this.currentTime = b, this.timelineTime = c, this.type = "finish", this.bubbles = !1, this.cancelable = !1, this.currentTarget = a1, this.defaultPrevented = !1, this.eventPhase = Event.AT_TARGET, this.timeStamp = Date.now();
            };
            b.Animation = function(b) {
                this.id = "", b && b._id && (this.id = b._id), this._sequenceNumber = a1.sequenceNumber++, this._currentTime = 0, this._startTime = null, this._paused = !1, this._playbackRate = 1, this._inTimeline = !0, this._finishedFlag = !0, this.onfinish = null, this._finishHandlers = [], this._effect = b, this._inEffect = this._effect._update(0), this._idle = !0, this._currentTimePending = !1;
            }, b.Animation.prototype = {
                _ensureAlive: function() {
                    this.playbackRate < 0 && 0 === this.currentTime ? this._inEffect = this._effect._update(-1) : this._inEffect = this._effect._update(this.currentTime), this._inTimeline || !this._inEffect && this._finishedFlag || (this._inTimeline = !0, b.timeline._animations.push(this));
                },
                _tickCurrentTime: function(a1, b) {
                    a1 != this._currentTime && (this._currentTime = a1, this._isFinished && !b && (this._currentTime = this._playbackRate > 0 ? this._totalDuration : 0), this._ensureAlive());
                },
                get currentTime () {
                    return this._idle || this._currentTimePending ? null : this._currentTime;
                },
                set currentTime (a){
                    a = +a, isNaN(a) || (b.restart(), this._paused || null == this._startTime || (this._startTime = this._timeline.currentTime - a / this._playbackRate), this._currentTimePending = !1, this._currentTime != a && (this._idle && (this._idle = !1, this._paused = !0), this._tickCurrentTime(a, !0), b.applyDirtiedAnimation(this)));
                },
                get startTime () {
                    return this._startTime;
                },
                set startTime (a){
                    a = +a, isNaN(a) || this._paused || this._idle || (this._startTime = a, this._tickCurrentTime((this._timeline.currentTime - this._startTime) * this.playbackRate), b.applyDirtiedAnimation(this));
                },
                get playbackRate () {
                    return this._playbackRate;
                },
                set playbackRate (a){
                    if (a != this._playbackRate) {
                        var c1 = this.currentTime;
                        this._playbackRate = a, this._startTime = null, "paused" != this.playState && "idle" != this.playState && (this._finishedFlag = !1, this._idle = !1, this._ensureAlive(), b.applyDirtiedAnimation(this)), null != c1 && (this.currentTime = c1);
                    }
                },
                get _isFinished () {
                    return !this._idle && (this._playbackRate > 0 && this._currentTime >= this._totalDuration || this._playbackRate < 0 && this._currentTime <= 0);
                },
                get _totalDuration () {
                    return this._effect._totalDuration;
                },
                get playState () {
                    return this._idle ? "idle" : null == this._startTime && !this._paused && 0 != this.playbackRate || this._currentTimePending ? "pending" : this._paused ? "paused" : this._isFinished ? "finished" : "running";
                },
                _rewind: function() {
                    if (this._playbackRate >= 0) this._currentTime = 0;
                    else {
                        if (!(this._totalDuration < 1 / 0)) throw new DOMException("Unable to rewind negative playback rate animation with infinite duration", "InvalidStateError");
                        this._currentTime = this._totalDuration;
                    }
                },
                play: function() {
                    this._paused = !1, (this._isFinished || this._idle) && (this._rewind(), this._startTime = null), this._finishedFlag = !1, this._idle = !1, this._ensureAlive(), b.applyDirtiedAnimation(this);
                },
                pause: function() {
                    this._isFinished || this._paused || this._idle ? this._idle && (this._rewind(), this._idle = !1) : this._currentTimePending = !0, this._startTime = null, this._paused = !0;
                },
                finish: function() {
                    this._idle || (this.currentTime = this._playbackRate > 0 ? this._totalDuration : 0, this._startTime = this._totalDuration - this.currentTime, this._currentTimePending = !1, b.applyDirtiedAnimation(this));
                },
                cancel: function() {
                    this._inEffect && (this._inEffect = !1, this._idle = !0, this._paused = !1, this._finishedFlag = !0, this._currentTime = 0, this._startTime = null, this._effect._update(null), b.applyDirtiedAnimation(this));
                },
                reverse: function() {
                    this.playbackRate *= -1, this.play();
                },
                addEventListener: function(a1, b) {
                    "function" == typeof b && "finish" == a1 && this._finishHandlers.push(b);
                },
                removeEventListener: function(a1, b) {
                    if ("finish" == a1) {
                        var c = this._finishHandlers.indexOf(b);
                        c >= 0 && this._finishHandlers.splice(c, 1);
                    }
                },
                _fireEvents: function(a1) {
                    if (this._isFinished) {
                        if (!this._finishedFlag) {
                            var b = new d(this, this._currentTime, a1), c = this._finishHandlers.concat(this.onfinish ? [
                                this.onfinish
                            ] : []);
                            setTimeout(function() {
                                c.forEach(function(a1) {
                                    a1.call(b.target, b);
                                });
                            }, 0), this._finishedFlag = !0;
                        }
                    } else this._finishedFlag = !1;
                },
                _tick: function(a1, b) {
                    this._idle || this._paused || (null == this._startTime ? b && (this.startTime = a1 - this._currentTime / this.playbackRate) : this._isFinished || this._tickCurrentTime((a1 - this._startTime) * this.playbackRate)), b && (this._currentTimePending = !1, this._fireEvents(a1));
                },
                get _needsTick () {
                    return this.playState in {
                        pending: 1,
                        running: 1
                    } || !this._finishedFlag;
                },
                _targetAnimations: function() {
                    var a1 = this._effect._target;
                    return a1._activeAnimations || (a1._activeAnimations = []), a1._activeAnimations;
                },
                _markTarget: function() {
                    var a1 = this._targetAnimations();
                    -1 === a1.indexOf(this) && a1.push(this);
                },
                _unmarkTarget: function() {
                    var a1 = this._targetAnimations(), b = a1.indexOf(this);
                    -1 !== b && a1.splice(b, 1);
                }
            };
        }(a1, b), function(a1, b, c) {
            function d(a1) {
                var b = j;
                j = [], a1 < q.currentTime && (a1 = q.currentTime), q._animations.sort(e), q._animations = h(a1, !0, q._animations)[0], b.forEach(function(b) {
                    b[1](a1);
                }), g(), l = void 0;
            }
            function e(a1, b) {
                return a1._sequenceNumber - b._sequenceNumber;
            }
            function f() {
                this._animations = [], this.currentTime = window.performance && performance.now ? performance.now() : 0;
            }
            function g() {
                o.forEach(function(a1) {
                    a1();
                }), o.length = 0;
            }
            function h(a1, c, d) {
                p = !0, n = !1, b.timeline.currentTime = a1, m = !1;
                var e = [], f = [], g = [], h = [];
                return d.forEach(function(b) {
                    b._tick(a1, c), b._inEffect ? (f.push(b._effect), b._markTarget()) : (e.push(b._effect), b._unmarkTarget()), b._needsTick && (m = !0);
                    var d = b._inEffect || b._needsTick;
                    b._inTimeline = d, d ? g.push(b) : h.push(b);
                }), o.push.apply(o, e), o.push.apply(o, f), m && requestAnimationFrame(function() {}), p = !1, [
                    g,
                    h
                ];
            }
            var i = window.requestAnimationFrame, j = [], k = 0;
            window.requestAnimationFrame = function(a1) {
                var b = k++;
                return 0 == j.length && i(d), j.push([
                    b,
                    a1
                ]), b;
            }, window.cancelAnimationFrame = function(a1) {
                j.forEach(function(b) {
                    b[0] == a1 && (b[1] = function() {});
                });
            }, f.prototype = {
                _play: function(c) {
                    c._timing = a1.normalizeTimingInput(c.timing);
                    var d = new b.Animation(c);
                    return d._idle = !1, d._timeline = this, this._animations.push(d), b.restart(), b.applyDirtiedAnimation(d), d;
                }
            };
            var l = void 0, m = !1, n = !1;
            b.restart = function() {
                return m || (m = !0, requestAnimationFrame(function() {}), n = !0), n;
            }, b.applyDirtiedAnimation = function(a1) {
                if (!p) {
                    a1._markTarget();
                    var c = a1._targetAnimations();
                    c.sort(e), h(b.timeline.currentTime, !1, c.slice())[1].forEach(function(a1) {
                        var b = q._animations.indexOf(a1);
                        -1 !== b && q._animations.splice(b, 1);
                    }), g();
                }
            };
            var o = [], p = !1, q = new f;
            b.timeline = q;
        }(a1, b), function(a1) {
            function b(a1, b) {
                var c = a1.exec(b);
                if (c) return c = a1.ignoreCase ? c[0].toLowerCase() : c[0], [
                    c,
                    b.substr(c.length)
                ];
            }
            function c(a1, b) {
                b = b.replace(/^\s*/, "");
                var c = a1(b);
                if (c) return [
                    c[0],
                    c[1].replace(/^\s*/, "")
                ];
            }
            function d(a1, d, e) {
                a1 = c.bind(null, a1);
                for(var f = [];;){
                    var g = a1(e);
                    if (!g) return [
                        f,
                        e
                    ];
                    if (f.push(g[0]), e = g[1], !(g = b(d, e)) || "" == g[1]) return [
                        f,
                        e
                    ];
                    e = g[1];
                }
            }
            function e(a1, b) {
                for(var c = 0, d = 0; d < b.length && (!/\s|,/.test(b[d]) || 0 != c); d++)if ("(" == b[d]) c++;
                else if (")" == b[d] && (c--, 0 == c && d++, c <= 0)) break;
                var e = a1(b.substr(0, d));
                return void 0 == e ? void 0 : [
                    e,
                    b.substr(d)
                ];
            }
            function f(a1, b) {
                for(var c = a1, d = b; c && d;)c > d ? c %= d : d %= c;
                return c = a1 * b / (c + d);
            }
            function g(a1) {
                return function(b) {
                    var c = a1(b);
                    return c && (c[0] = void 0), c;
                };
            }
            function h(a1, b) {
                return function(c) {
                    return a1(c) || [
                        b,
                        c
                    ];
                };
            }
            function i(b, c) {
                for(var d = [], e = 0; e < b.length; e++){
                    var f = a1.consumeTrimmed(b[e], c);
                    if (!f || "" == f[0]) return;
                    void 0 !== f[0] && d.push(f[0]), c = f[1];
                }
                if ("" == c) return d;
            }
            function j(a1, b, c, d, e) {
                for(var g = [], h = [], i = [], j = f(d.length, e.length), k = 0; k < j; k++){
                    var l = b(d[k % d.length], e[k % e.length]);
                    if (!l) return;
                    g.push(l[0]), h.push(l[1]), i.push(l[2]);
                }
                return [
                    g,
                    h,
                    function(b) {
                        var d = b.map(function(a1, b) {
                            return i[b](a1);
                        }).join(c);
                        return a1 ? a1(d) : d;
                    }
                ];
            }
            function k(a1, b, c) {
                for(var d = [], e = [], f = [], g = 0, h = 0; h < c.length; h++)if ("function" == typeof c[h]) {
                    var i = c[h](a1[g], b[g++]);
                    d.push(i[0]), e.push(i[1]), f.push(i[2]);
                } else !function(a1) {
                    d.push(!1), e.push(!1), f.push(function() {
                        return c[a1];
                    });
                }(h);
                return [
                    d,
                    e,
                    function(a1) {
                        for(var b = "", c = 0; c < a1.length; c++)b += f[c](a1[c]);
                        return b;
                    }
                ];
            }
            a1.consumeToken = b, a1.consumeTrimmed = c, a1.consumeRepeated = d, a1.consumeParenthesised = e, a1.ignore = g, a1.optional = h, a1.consumeList = i, a1.mergeNestedRepeated = j.bind(null, null), a1.mergeWrappedNestedRepeated = j, a1.mergeList = k;
        }(b), function(a1) {
            function b(b) {
                function c(b) {
                    var c = a1.consumeToken(/^inset/i, b);
                    return c ? (d.inset = !0, c) : (c = a1.consumeLengthOrPercent(b)) ? (d.lengths.push(c[0]), c) : (c = a1.consumeColor(b), c ? (d.color = c[0], c) : void 0);
                }
                var d = {
                    inset: !1,
                    lengths: [],
                    color: null
                }, e = a1.consumeRepeated(c, /^/, b);
                if (e && e[0].length) return [
                    d,
                    e[1]
                ];
            }
            function c(c) {
                var d = a1.consumeRepeated(b, /^,/, c);
                if (d && "" == d[1]) return d[0];
            }
            function d(b, c) {
                for(; b.lengths.length < Math.max(b.lengths.length, c.lengths.length);)b.lengths.push({
                    px: 0
                });
                for(; c.lengths.length < Math.max(b.lengths.length, c.lengths.length);)c.lengths.push({
                    px: 0
                });
                if (b.inset == c.inset && !!b.color == !!c.color) {
                    for(var d, e = [], f = [
                        [],
                        0
                    ], g = [
                        [],
                        0
                    ], h = 0; h < b.lengths.length; h++){
                        var i = a1.mergeDimensions(b.lengths[h], c.lengths[h], 2 == h);
                        f[0].push(i[0]), g[0].push(i[1]), e.push(i[2]);
                    }
                    if (b.color && c.color) {
                        var j = a1.mergeColors(b.color, c.color);
                        f[1] = j[0], g[1] = j[1], d = j[2];
                    }
                    return [
                        f,
                        g,
                        function(a1) {
                            for(var c = b.inset ? "inset " : " ", f = 0; f < e.length; f++)c += e[f](a1[0][f]) + " ";
                            return d && (c += d(a1[1])), c;
                        }
                    ];
                }
            }
            function e(b, c, d, e) {
                function f(a1) {
                    return {
                        inset: a1,
                        color: [
                            0,
                            0,
                            0,
                            0
                        ],
                        lengths: [
                            {
                                px: 0
                            },
                            {
                                px: 0
                            },
                            {
                                px: 0
                            },
                            {
                                px: 0
                            }
                        ]
                    };
                }
                for(var g = [], h = [], i = 0; i < d.length || i < e.length; i++){
                    var j = d[i] || f(e[i].inset), k = e[i] || f(d[i].inset);
                    g.push(j), h.push(k);
                }
                return a1.mergeNestedRepeated(b, c, g, h);
            }
            var f = e.bind(null, d, ", ");
            a1.addPropertiesHandler(c, f, [
                "box-shadow",
                "text-shadow"
            ]);
        }(b), function(a1, b) {
            function c(a1) {
                return a1.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
            }
            function d(a1, b, c) {
                return Math.min(b, Math.max(a1, c));
            }
            function e(a1) {
                if (/^\s*[-+]?(\d*\.)?\d+\s*$/.test(a1)) return Number(a1);
            }
            function f(a1, b) {
                return [
                    a1,
                    b,
                    c
                ];
            }
            function g(a1, b) {
                if (0 != a1) return i(0, 1 / 0)(a1, b);
            }
            function h(a1, b) {
                return [
                    a1,
                    b,
                    function(a1) {
                        return Math.round(d(1, 1 / 0, a1));
                    }
                ];
            }
            function i(a1, b) {
                return function(e, f) {
                    return [
                        e,
                        f,
                        function(e) {
                            return c(d(a1, b, e));
                        }
                    ];
                };
            }
            function j(a1) {
                var b = a1.trim().split(/\s*[\s,]\s*/);
                if (0 !== b.length) {
                    for(var c = [], d = 0; d < b.length; d++){
                        var f = e(b[d]);
                        if (void 0 === f) return;
                        c.push(f);
                    }
                    return c;
                }
            }
            function k(a1, b) {
                if (a1.length == b.length) return [
                    a1,
                    b,
                    function(a1) {
                        return a1.map(c).join(" ");
                    }
                ];
            }
            function l(a1, b) {
                return [
                    a1,
                    b,
                    Math.round
                ];
            }
            a1.clamp = d, a1.addPropertiesHandler(j, k, [
                "stroke-dasharray"
            ]), a1.addPropertiesHandler(e, i(0, 1 / 0), [
                "border-image-width",
                "line-height"
            ]), a1.addPropertiesHandler(e, i(0, 1), [
                "opacity",
                "shape-image-threshold"
            ]), a1.addPropertiesHandler(e, g, [
                "flex-grow",
                "flex-shrink"
            ]), a1.addPropertiesHandler(e, h, [
                "orphans",
                "widows"
            ]), a1.addPropertiesHandler(e, l, [
                "z-index"
            ]), a1.parseNumber = e, a1.parseNumberList = j, a1.mergeNumbers = f, a1.numberToString = c;
        }(b), function(a1, b) {
            function c(a1, b) {
                if ("visible" == a1 || "visible" == b) return [
                    0,
                    1,
                    function(c) {
                        return c <= 0 ? a1 : c >= 1 ? b : "visible";
                    }
                ];
            }
            a1.addPropertiesHandler(String, c, [
                "visibility"
            ]);
        }(b), function(a1, b) {
            function c(a1) {
                a1 = a1.trim(), f.fillStyle = "#000", f.fillStyle = a1;
                var b = f.fillStyle;
                if (f.fillStyle = "#fff", f.fillStyle = a1, b == f.fillStyle) {
                    f.fillRect(0, 0, 1, 1);
                    var c = f.getImageData(0, 0, 1, 1).data;
                    f.clearRect(0, 0, 1, 1);
                    var d = c[3] / 255;
                    return [
                        c[0] * d,
                        c[1] * d,
                        c[2] * d,
                        d
                    ];
                }
            }
            function d(b, c) {
                return [
                    b,
                    c,
                    function(b) {
                        function c(a1) {
                            return Math.max(0, Math.min(255, a1));
                        }
                        if (b[3]) for(var d = 0; d < 3; d++)b[d] = Math.round(c(b[d] / b[3]));
                        return b[3] = a1.numberToString(a1.clamp(0, 1, b[3])), "rgba(" + b.join(",") + ")";
                    }
                ];
            }
            var e = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
            e.width = e.height = 1;
            var f = e.getContext("2d");
            a1.addPropertiesHandler(c, d, [
                "background-color",
                "border-bottom-color",
                "border-left-color",
                "border-right-color",
                "border-top-color",
                "color",
                "fill",
                "flood-color",
                "lighting-color",
                "outline-color",
                "stop-color",
                "stroke",
                "text-decoration-color"
            ]), a1.consumeColor = a1.consumeParenthesised.bind(null, c), a1.mergeColors = d;
        }(b), function(a1, b) {
            function c(a1) {
                function b() {
                    var b = h.exec(a1);
                    g = b ? b[0] : void 0;
                }
                function c() {
                    var a1 = Number(g);
                    return b(), a1;
                }
                function d() {
                    if ("(" !== g) return c();
                    b();
                    var a1 = f();
                    return ")" !== g ? NaN : (b(), a1);
                }
                function e() {
                    for(var a1 = d(); "*" === g || "/" === g;){
                        var c = g;
                        b();
                        var e = d();
                        "*" === c ? a1 *= e : a1 /= e;
                    }
                    return a1;
                }
                function f() {
                    for(var a1 = e(); "+" === g || "-" === g;){
                        var c = g;
                        b();
                        var d = e();
                        "+" === c ? a1 += d : a1 -= d;
                    }
                    return a1;
                }
                var g, h = /([\+\-\w\.]+|[\(\)\*\/])/g;
                return b(), f();
            }
            function d(a1, b) {
                if ("0" == (b = b.trim().toLowerCase()) && "px".search(a1) >= 0) return {
                    px: 0
                };
                if (/^[^(]*$|^calc/.test(b)) {
                    b = b.replace(/calc\(/g, "(");
                    var d = {};
                    b = b.replace(a1, function(a1) {
                        return d[a1] = null, "U" + a1;
                    });
                    for(var e = "U(" + a1.source + ")", f = b.replace(/[-+]?(\d*\.)?\d+([Ee][-+]?\d+)?/g, "N").replace(new RegExp("N" + e, "g"), "D").replace(/\s[+-]\s/g, "O").replace(/\s/g, ""), g = [
                        /N\*(D)/g,
                        /(N|D)[*\/]N/g,
                        /(N|D)O\1/g,
                        /\((N|D)\)/g
                    ], h = 0; h < g.length;)g[h].test(f) ? (f = f.replace(g[h], "$1"), h = 0) : h++;
                    if ("D" == f) {
                        for(var i in d){
                            var j = c(b.replace(new RegExp("U" + i, "g"), "").replace(new RegExp(e, "g"), "*0"));
                            if (!isFinite(j)) return;
                            d[i] = j;
                        }
                        return d;
                    }
                }
            }
            function e(a1, b) {
                return f(a1, b, !0);
            }
            function f(b, c, d) {
                var e, f = [];
                for(e in b)f.push(e);
                for(e in c)f.indexOf(e) < 0 && f.push(e);
                return b = f.map(function(a1) {
                    return b[a1] || 0;
                }), c = f.map(function(a1) {
                    return c[a1] || 0;
                }), [
                    b,
                    c,
                    function(b) {
                        var c = b.map(function(c, e) {
                            return 1 == b.length && d && (c = Math.max(c, 0)), a1.numberToString(c) + f[e];
                        }).join(" + ");
                        return b.length > 1 ? "calc(" + c + ")" : c;
                    }
                ];
            }
            var g = "px|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc", h = d.bind(null, new RegExp(g, "g")), i = d.bind(null, new RegExp(g + "|%", "g")), j = d.bind(null, /deg|rad|grad|turn/g);
            a1.parseLength = h, a1.parseLengthOrPercent = i, a1.consumeLengthOrPercent = a1.consumeParenthesised.bind(null, i), a1.parseAngle = j, a1.mergeDimensions = f;
            var k = a1.consumeParenthesised.bind(null, h), l = a1.consumeRepeated.bind(void 0, k, /^/), m = a1.consumeRepeated.bind(void 0, l, /^,/);
            a1.consumeSizePairList = m;
            var n = function(a1) {
                var b = m(a1);
                if (b && "" == b[1]) return b[0];
            }, o = a1.mergeNestedRepeated.bind(void 0, e, " "), p = a1.mergeNestedRepeated.bind(void 0, o, ",");
            a1.mergeNonNegativeSizePair = o, a1.addPropertiesHandler(n, p, [
                "background-size"
            ]), a1.addPropertiesHandler(i, e, [
                "border-bottom-width",
                "border-image-width",
                "border-left-width",
                "border-right-width",
                "border-top-width",
                "flex-basis",
                "font-size",
                "height",
                "line-height",
                "max-height",
                "max-width",
                "outline-width",
                "width"
            ]), a1.addPropertiesHandler(i, f, [
                "border-bottom-left-radius",
                "border-bottom-right-radius",
                "border-top-left-radius",
                "border-top-right-radius",
                "bottom",
                "left",
                "letter-spacing",
                "margin-bottom",
                "margin-left",
                "margin-right",
                "margin-top",
                "min-height",
                "min-width",
                "outline-offset",
                "padding-bottom",
                "padding-left",
                "padding-right",
                "padding-top",
                "perspective",
                "right",
                "shape-margin",
                "stroke-dashoffset",
                "text-indent",
                "top",
                "vertical-align",
                "word-spacing"
            ]);
        }(b), function(a1, b) {
            function c(b) {
                return a1.consumeLengthOrPercent(b) || a1.consumeToken(/^auto/, b);
            }
            function d(b) {
                var d = a1.consumeList([
                    a1.ignore(a1.consumeToken.bind(null, /^rect/)),
                    a1.ignore(a1.consumeToken.bind(null, /^\(/)),
                    a1.consumeRepeated.bind(null, c, /^,/),
                    a1.ignore(a1.consumeToken.bind(null, /^\)/))
                ], b);
                if (d && 4 == d[0].length) return d[0];
            }
            function e(b, c) {
                return "auto" == b || "auto" == c ? [
                    !0,
                    !1,
                    function(d) {
                        var e = d ? b : c;
                        if ("auto" == e) return "auto";
                        var f = a1.mergeDimensions(e, e);
                        return f[2](f[0]);
                    }
                ] : a1.mergeDimensions(b, c);
            }
            function f(a1) {
                return "rect(" + a1 + ")";
            }
            var g = a1.mergeWrappedNestedRepeated.bind(null, f, e, ", ");
            a1.parseBox = d, a1.mergeBoxes = g, a1.addPropertiesHandler(d, g, [
                "clip"
            ]);
        }(b), function(a1, b) {
            function c(a1) {
                return function(b) {
                    var c = 0;
                    return a1.map(function(a1) {
                        return a1 === k ? b[c++] : a1;
                    });
                };
            }
            function d(a1) {
                return a1;
            }
            function e(b) {
                if ("none" == (b = b.toLowerCase().trim())) return [];
                for(var c, d = /\s*(\w+)\(([^)]*)\)/g, e = [], f = 0; c = d.exec(b);){
                    if (c.index != f) return;
                    f = c.index + c[0].length;
                    var g = c[1], h = n[g];
                    if (!h) return;
                    var i = c[2].split(","), j = h[0];
                    if (j.length < i.length) return;
                    for(var k = [], o = 0; o < j.length; o++){
                        var p, q = i[o], r = j[o];
                        if (void 0 === (p = q ? ({
                            A: function(b) {
                                return "0" == b.trim() ? m : a1.parseAngle(b);
                            },
                            N: a1.parseNumber,
                            T: a1.parseLengthOrPercent,
                            L: a1.parseLength
                        })[r.toUpperCase()](q) : ({
                            a: m,
                            n: k[0],
                            t: l
                        })[r])) return;
                        k.push(p);
                    }
                    if (e.push({
                        t: g,
                        d: k
                    }), d.lastIndex == b.length) return e;
                }
            }
            function f(a1) {
                return a1.toFixed(6).replace(".000000", "");
            }
            function g(b, c) {
                if (b.decompositionPair !== c) {
                    b.decompositionPair = c;
                    var d = a1.makeMatrixDecomposition(b);
                }
                if (c.decompositionPair !== b) {
                    c.decompositionPair = b;
                    var e = a1.makeMatrixDecomposition(c);
                }
                return null == d[0] || null == e[0] ? [
                    [
                        !1
                    ],
                    [
                        !0
                    ],
                    function(a1) {
                        return a1 ? c[0].d : b[0].d;
                    }
                ] : (d[0].push(0), e[0].push(1), [
                    d,
                    e,
                    function(b) {
                        var c = a1.quat(d[0][3], e[0][3], b[5]);
                        return a1.composeMatrix(b[0], b[1], b[2], c, b[4]).map(f).join(",");
                    }
                ]);
            }
            function h(a1) {
                return a1.replace(/[xy]/, "");
            }
            function i(a1) {
                return a1.replace(/(x|y|z|3d)?$/, "3d");
            }
            function j(b, c) {
                var d = a1.makeMatrixDecomposition && !0, e = !1;
                if (!b.length || !c.length) {
                    b.length || (e = !0, b = c, c = []);
                    for(var f = 0; f < b.length; f++){
                        var j = b[f].t, k = b[f].d, l = "scale" == j.substr(0, 5) ? 1 : 0;
                        c.push({
                            t: j,
                            d: k.map(function(a1) {
                                if ("number" == typeof a1) return l;
                                var b = {};
                                for(var c in a1)b[c] = l;
                                return b;
                            })
                        });
                    }
                }
                var m = function(a1, b) {
                    return "perspective" == a1 && "perspective" == b || ("matrix" == a1 || "matrix3d" == a1) && ("matrix" == b || "matrix3d" == b);
                }, o = [], p = [], q = [];
                if (b.length != c.length) {
                    if (!d) return;
                    var r = g(b, c);
                    o = [
                        r[0]
                    ], p = [
                        r[1]
                    ], q = [
                        [
                            "matrix",
                            [
                                r[2]
                            ]
                        ]
                    ];
                } else for(var f = 0; f < b.length; f++){
                    var j, s = b[f].t, t = c[f].t, u = b[f].d, v = c[f].d, w = n[s], x = n[t];
                    if (m(s, t)) {
                        if (!d) return;
                        var r = g([
                            b[f]
                        ], [
                            c[f]
                        ]);
                        o.push(r[0]), p.push(r[1]), q.push([
                            "matrix",
                            [
                                r[2]
                            ]
                        ]);
                    } else {
                        if (s == t) j = s;
                        else if (w[2] && x[2] && h(s) == h(t)) j = h(s), u = w[2](u), v = x[2](v);
                        else {
                            if (!w[1] || !x[1] || i(s) != i(t)) {
                                if (!d) return;
                                var r = g(b, c);
                                o = [
                                    r[0]
                                ], p = [
                                    r[1]
                                ], q = [
                                    [
                                        "matrix",
                                        [
                                            r[2]
                                        ]
                                    ]
                                ];
                                break;
                            }
                            j = i(s), u = w[1](u), v = x[1](v);
                        }
                        for(var y = [], z = [], A = [], B = 0; B < u.length; B++){
                            var C = "number" == typeof u[B] ? a1.mergeNumbers : a1.mergeDimensions, r = C(u[B], v[B]);
                            y[B] = r[0], z[B] = r[1], A.push(r[2]);
                        }
                        o.push(y), p.push(z), q.push([
                            j,
                            A
                        ]);
                    }
                }
                if (e) {
                    var D = o;
                    o = p, p = D;
                }
                return [
                    o,
                    p,
                    function(a1) {
                        return a1.map(function(a1, b) {
                            var c = a1.map(function(a1, c) {
                                return q[b][1][c](a1);
                            }).join(",");
                            return "matrix" == q[b][0] && 16 == c.split(",").length && (q[b][0] = "matrix3d"), q[b][0] + "(" + c + ")";
                        }).join(" ");
                    }
                ];
            }
            var k = null, l = {
                px: 0
            }, m = {
                deg: 0
            }, n = {
                matrix: [
                    "NNNNNN",
                    [
                        k,
                        k,
                        0,
                        0,
                        k,
                        k,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        k,
                        k,
                        0,
                        1
                    ],
                    d
                ],
                matrix3d: [
                    "NNNNNNNNNNNNNNNN",
                    d
                ],
                rotate: [
                    "A"
                ],
                rotatex: [
                    "A"
                ],
                rotatey: [
                    "A"
                ],
                rotatez: [
                    "A"
                ],
                rotate3d: [
                    "NNNA"
                ],
                perspective: [
                    "L"
                ],
                scale: [
                    "Nn",
                    c([
                        k,
                        k,
                        1
                    ]),
                    d
                ],
                scalex: [
                    "N",
                    c([
                        k,
                        1,
                        1
                    ]),
                    c([
                        k,
                        1
                    ])
                ],
                scaley: [
                    "N",
                    c([
                        1,
                        k,
                        1
                    ]),
                    c([
                        1,
                        k
                    ])
                ],
                scalez: [
                    "N",
                    c([
                        1,
                        1,
                        k
                    ])
                ],
                scale3d: [
                    "NNN",
                    d
                ],
                skew: [
                    "Aa",
                    null,
                    d
                ],
                skewx: [
                    "A",
                    null,
                    c([
                        k,
                        m
                    ])
                ],
                skewy: [
                    "A",
                    null,
                    c([
                        m,
                        k
                    ])
                ],
                translate: [
                    "Tt",
                    c([
                        k,
                        k,
                        l
                    ]),
                    d
                ],
                translatex: [
                    "T",
                    c([
                        k,
                        l,
                        l
                    ]),
                    c([
                        k,
                        l
                    ])
                ],
                translatey: [
                    "T",
                    c([
                        l,
                        k,
                        l
                    ]),
                    c([
                        l,
                        k
                    ])
                ],
                translatez: [
                    "L",
                    c([
                        l,
                        l,
                        k
                    ])
                ],
                translate3d: [
                    "TTL",
                    d
                ]
            };
            a1.addPropertiesHandler(e, j, [
                "transform"
            ]), a1.transformToSvgMatrix = function(b) {
                var c = a1.transformListToMatrix(e(b));
                return "matrix(" + f(c[0]) + " " + f(c[1]) + " " + f(c[4]) + " " + f(c[5]) + " " + f(c[12]) + " " + f(c[13]) + ")";
            };
        }(b), function(a1, b) {
            function c(a1, b) {
                b.concat([
                    a1
                ]).forEach(function(b) {
                    b in document.documentElement.style && (d[a1] = b), e[b] = a1;
                });
            }
            var d = {}, e = {};
            c("transform", [
                "webkitTransform",
                "msTransform"
            ]), c("transformOrigin", [
                "webkitTransformOrigin"
            ]), c("perspective", [
                "webkitPerspective"
            ]), c("perspectiveOrigin", [
                "webkitPerspectiveOrigin"
            ]), a1.propertyName = function(a1) {
                return d[a1] || a1;
            }, a1.unprefixedPropertyName = function(a1) {
                return e[a1] || a1;
            };
        }(b);
    }(), function() {
        if (void 0 === document.createElement("div").animate([]).oncancel) {
            var a1;
            if (window.performance && performance.now) var a1 = function() {
                return performance.now();
            };
            else var a1 = function() {
                return Date.now();
            };
            var b = function(a1, b, c) {
                this.target = a1, this.currentTime = b, this.timelineTime = c, this.type = "cancel", this.bubbles = !1, this.cancelable = !1, this.currentTarget = a1, this.defaultPrevented = !1, this.eventPhase = Event.AT_TARGET, this.timeStamp = Date.now();
            }, c = window.Element.prototype.animate;
            window.Element.prototype.animate = function(d, e) {
                var f = c.call(this, d, e);
                f._cancelHandlers = [], f.oncancel = null;
                var g = f.cancel;
                f.cancel = function() {
                    g.call(this);
                    var c = new b(this, null, a1()), d = this._cancelHandlers.concat(this.oncancel ? [
                        this.oncancel
                    ] : []);
                    setTimeout(function() {
                        d.forEach(function(a1) {
                            a1.call(c.target, c);
                        });
                    }, 0);
                };
                var h = f.addEventListener;
                f.addEventListener = function(a1, b) {
                    "function" == typeof b && "cancel" == a1 ? this._cancelHandlers.push(b) : h.call(this, a1, b);
                };
                var i = f.removeEventListener;
                return f.removeEventListener = function(a1, b) {
                    if ("cancel" == a1) {
                        var c = this._cancelHandlers.indexOf(b);
                        c >= 0 && this._cancelHandlers.splice(c, 1);
                    } else i.call(this, a1, b);
                }, f;
            };
        }
    }(), function(a1) {
        var b = document.documentElement, c = null, d = !1;
        try {
            var e = getComputedStyle(b).getPropertyValue("opacity"), f = "0" == e ? "1" : "0";
            c = b.animate({
                opacity: [
                    f,
                    f
                ]
            }, {
                duration: 1
            }), c.currentTime = 0, d = getComputedStyle(b).getPropertyValue("opacity") == f;
        } catch (a1) {} finally{
            c && c.cancel();
        }
        if (!d) {
            var g = window.Element.prototype.animate;
            window.Element.prototype.animate = function(b, c) {
                return window.Symbol && Symbol.iterator && Array.prototype.from && b[Symbol.iterator] && (b = Array.from(b)), Array.isArray(b) || null === b || (b = a1.convertToArrayForm(b)), g.call(this, b, c);
            };
        }
    }(a1), function(a1, b, c) {
        function d(a1) {
            var c = b.timeline;
            c.currentTime = a1, c._discardAnimations(), 0 == c._animations.length ? f = !1 : requestAnimationFrame(d);
        }
        var e = window.requestAnimationFrame;
        window.requestAnimationFrame = function(a1) {
            return e(function(c) {
                b.timeline._updateAnimationsPromises(), a1(c), b.timeline._updateAnimationsPromises();
            });
        }, b.AnimationTimeline = function() {
            this._animations = [], this.currentTime = void 0;
        }, b.AnimationTimeline.prototype = {
            getAnimations: function() {
                return this._discardAnimations(), this._animations.slice();
            },
            _updateAnimationsPromises: function() {
                b.animationsWithPromises = b.animationsWithPromises.filter(function(a1) {
                    return a1._updatePromises();
                });
            },
            _discardAnimations: function() {
                this._updateAnimationsPromises(), this._animations = this._animations.filter(function(a1) {
                    return "finished" != a1.playState && "idle" != a1.playState;
                });
            },
            _play: function(a1) {
                var c = new b.Animation(a1, this);
                return this._animations.push(c), b.restartWebAnimationsNextTick(), c._updatePromises(), c._animation.play(), c._updatePromises(), c;
            },
            play: function(a1) {
                return a1 && a1.remove(), this._play(a1);
            }
        };
        var f = !1;
        b.restartWebAnimationsNextTick = function() {
            f || (f = !0, requestAnimationFrame(d));
        };
        var g = new b.AnimationTimeline;
        b.timeline = g;
        try {
            Object.defineProperty(window.document, "timeline", {
                configurable: !0,
                get: function() {
                    return g;
                }
            });
        } catch (a1) {}
        try {
            window.document.timeline = g;
        } catch (a1) {}
    }(0, c), function(a1, b, c) {
        b.animationsWithPromises = [], b.Animation = function(b, c) {
            if (this.id = "", b && b._id && (this.id = b._id), this.effect = b, b && (b._animation = this), !c) throw new Error("Animation with null timeline is not supported");
            this._timeline = c, this._sequenceNumber = a1.sequenceNumber++, this._holdTime = 0, this._paused = !1, this._isGroup = !1, this._animation = null, this._childAnimations = [], this._callback = null, this._oldPlayState = "idle", this._rebuildUnderlyingAnimation(), this._animation.cancel(), this._updatePromises();
        }, b.Animation.prototype = {
            _updatePromises: function() {
                var a1 = this._oldPlayState, b = this.playState;
                return this._readyPromise && b !== a1 && ("idle" == b ? (this._rejectReadyPromise(), this._readyPromise = void 0) : "pending" == a1 ? this._resolveReadyPromise() : "pending" == b && (this._readyPromise = void 0)), this._finishedPromise && b !== a1 && ("idle" == b ? (this._rejectFinishedPromise(), this._finishedPromise = void 0) : "finished" == b ? this._resolveFinishedPromise() : "finished" == a1 && (this._finishedPromise = void 0)), this._oldPlayState = this.playState, this._readyPromise || this._finishedPromise;
            },
            _rebuildUnderlyingAnimation: function() {
                this._updatePromises();
                var a1, c, d, e, f = !!this._animation;
                f && (a1 = this.playbackRate, c = this._paused, d = this.startTime, e = this.currentTime, this._animation.cancel(), this._animation._wrapper = null, this._animation = null), (!this.effect || this.effect instanceof window.KeyframeEffect) && (this._animation = b.newUnderlyingAnimationForKeyframeEffect(this.effect), b.bindAnimationForKeyframeEffect(this)), (this.effect instanceof window.SequenceEffect || this.effect instanceof window.GroupEffect) && (this._animation = b.newUnderlyingAnimationForGroup(this.effect), b.bindAnimationForGroup(this)), this.effect && this.effect._onsample && b.bindAnimationForCustomEffect(this), f && (1 != a1 && (this.playbackRate = a1), null !== d ? this.startTime = d : null !== e ? this.currentTime = e : null !== this._holdTime && (this.currentTime = this._holdTime), c && this.pause()), this._updatePromises();
            },
            _updateChildren: function() {
                if (this.effect && "idle" != this.playState) {
                    var a1 = this.effect._timing.delay;
                    this._childAnimations.forEach((function(c) {
                        this._arrangeChildren(c, a1), this.effect instanceof window.SequenceEffect && (a1 += b.groupChildDuration(c.effect));
                    }).bind(this));
                }
            },
            _setExternalAnimation: function(a1) {
                if (this.effect && this._isGroup) for(var b = 0; b < this.effect.children.length; b++)this.effect.children[b]._animation = a1, this._childAnimations[b]._setExternalAnimation(a1);
            },
            _constructChildAnimations: function() {
                if (this.effect && this._isGroup) {
                    var a1 = this.effect._timing.delay;
                    this._removeChildAnimations(), this.effect.children.forEach((function(c) {
                        var d = b.timeline._play(c);
                        this._childAnimations.push(d), d.playbackRate = this.playbackRate, this._paused && d.pause(), c._animation = this.effect._animation, this._arrangeChildren(d, a1), this.effect instanceof window.SequenceEffect && (a1 += b.groupChildDuration(c));
                    }).bind(this));
                }
            },
            _arrangeChildren: function(a1, b) {
                null === this.startTime ? a1.currentTime = this.currentTime - b / this.playbackRate : a1.startTime !== this.startTime + b / this.playbackRate && (a1.startTime = this.startTime + b / this.playbackRate);
            },
            get timeline () {
                return this._timeline;
            },
            get playState () {
                return this._animation ? this._animation.playState : "idle";
            },
            get finished () {
                return window.Promise ? (this._finishedPromise || (-1 == b.animationsWithPromises.indexOf(this) && b.animationsWithPromises.push(this), this._finishedPromise = new Promise((function(a1, b) {
                    this._resolveFinishedPromise = function() {
                        a1(this);
                    }, this._rejectFinishedPromise = function() {
                        b({
                            type: DOMException.ABORT_ERR,
                            name: "AbortError"
                        });
                    };
                }).bind(this)), "finished" == this.playState && this._resolveFinishedPromise()), this._finishedPromise) : (console.warn("Animation Promises require JavaScript Promise constructor"), null);
            },
            get ready () {
                return window.Promise ? (this._readyPromise || (-1 == b.animationsWithPromises.indexOf(this) && b.animationsWithPromises.push(this), this._readyPromise = new Promise((function(a1, b) {
                    this._resolveReadyPromise = function() {
                        a1(this);
                    }, this._rejectReadyPromise = function() {
                        b({
                            type: DOMException.ABORT_ERR,
                            name: "AbortError"
                        });
                    };
                }).bind(this)), "pending" !== this.playState && this._resolveReadyPromise()), this._readyPromise) : (console.warn("Animation Promises require JavaScript Promise constructor"), null);
            },
            get onfinish () {
                return this._animation.onfinish;
            },
            set onfinish (a){
                this._animation.onfinish = "function" == typeof a ? (function(b) {
                    b.target = this, a.call(this, b);
                }).bind(this) : a;
            },
            get oncancel () {
                return this._animation.oncancel;
            },
            set oncancel (a){
                this._animation.oncancel = "function" == typeof a ? (function(b) {
                    b.target = this, a.call(this, b);
                }).bind(this) : a;
            },
            get currentTime () {
                this._updatePromises();
                var a2 = this._animation.currentTime;
                return this._updatePromises(), a2;
            },
            set currentTime (a){
                this._updatePromises(), this._animation.currentTime = isFinite(a) ? a : Math.sign(a) * Number.MAX_VALUE, this._register(), this._forEachChild(function(b, c) {
                    b.currentTime = a - c;
                }), this._updatePromises();
            },
            get startTime () {
                return this._animation.startTime;
            },
            set startTime (a){
                this._updatePromises(), this._animation.startTime = isFinite(a) ? a : Math.sign(a) * Number.MAX_VALUE, this._register(), this._forEachChild(function(b, c) {
                    b.startTime = a + c;
                }), this._updatePromises();
            },
            get playbackRate () {
                return this._animation.playbackRate;
            },
            set playbackRate (a){
                this._updatePromises();
                var b1 = this.currentTime;
                this._animation.playbackRate = a, this._forEachChild(function(b) {
                    b.playbackRate = a;
                }), null !== b1 && (this.currentTime = b1), this._updatePromises();
            },
            play: function() {
                this._updatePromises(), this._paused = !1, this._animation.play(), -1 == this._timeline._animations.indexOf(this) && this._timeline._animations.push(this), this._register(), b.awaitStartTime(this), this._forEachChild(function(a1) {
                    var b = a1.currentTime;
                    a1.play(), a1.currentTime = b;
                }), this._updatePromises();
            },
            pause: function() {
                this._updatePromises(), this.currentTime && (this._holdTime = this.currentTime), this._animation.pause(), this._register(), this._forEachChild(function(a1) {
                    a1.pause();
                }), this._paused = !0, this._updatePromises();
            },
            finish: function() {
                this._updatePromises(), this._animation.finish(), this._register(), this._updatePromises();
            },
            cancel: function() {
                this._updatePromises(), this._animation.cancel(), this._register(), this._removeChildAnimations(), this._updatePromises();
            },
            reverse: function() {
                this._updatePromises();
                var a1 = this.currentTime;
                this._animation.reverse(), this._forEachChild(function(a1) {
                    a1.reverse();
                }), null !== a1 && (this.currentTime = a1), this._updatePromises();
            },
            addEventListener: function(a1, b) {
                var c = b;
                "function" == typeof b && (c = (function(a1) {
                    a1.target = this, b.call(this, a1);
                }).bind(this), b._wrapper = c), this._animation.addEventListener(a1, c);
            },
            removeEventListener: function(a1, b) {
                this._animation.removeEventListener(a1, b && b._wrapper || b);
            },
            _removeChildAnimations: function() {
                for(; this._childAnimations.length;)this._childAnimations.pop().cancel();
            },
            _forEachChild: function(b) {
                var c = 0;
                if (this.effect.children && this._childAnimations.length < this.effect.children.length && this._constructChildAnimations(), this._childAnimations.forEach((function(a1) {
                    b.call(this, a1, c), this.effect instanceof window.SequenceEffect && (c += a1.effect.activeDuration);
                }).bind(this)), "pending" != this.playState) {
                    var d = this.effect._timing, e = this.currentTime;
                    null !== e && (e = a1.calculateIterationProgress(a1.calculateActiveDuration(d), e, d)), (null == e || isNaN(e)) && this._removeChildAnimations();
                }
            }
        }, window.Animation = b.Animation;
    }(a1, c), function(a1, b, c) {
        function d(b) {
            this._frames = a1.normalizeKeyframes(b);
        }
        function e() {
            for(var a1 = !1; i.length;)i.shift()._updateChildren(), a1 = !0;
            return a1;
        }
        var f = function(a1) {
            if (a1._animation = void 0, a1 instanceof window.SequenceEffect || a1 instanceof window.GroupEffect) for(var b = 0; b < a1.children.length; b++)f(a1.children[b]);
        };
        b.removeMulti = function(a1) {
            for(var b = [], c = 0; c < a1.length; c++){
                var d = a1[c];
                d._parent ? (-1 == b.indexOf(d._parent) && b.push(d._parent), d._parent.children.splice(d._parent.children.indexOf(d), 1), d._parent = null, f(d)) : d._animation && d._animation.effect == d && (d._animation.cancel(), d._animation.effect = new KeyframeEffect(null, []), d._animation._callback && (d._animation._callback._animation = null), d._animation._rebuildUnderlyingAnimation(), f(d));
            }
            for(c = 0; c < b.length; c++)b[c]._rebuild();
        }, b.KeyframeEffect = function(b, c, e, f) {
            return this.target = b, this._parent = null, e = a1.numericTimingToObject(e), this._timingInput = a1.cloneTimingInput(e), this._timing = a1.normalizeTimingInput(e), this.timing = a1.makeTiming(e, !1, this), this.timing._effect = this, "function" == typeof c ? (a1.deprecated("Custom KeyframeEffect", "2015-06-22", "Use KeyframeEffect.onsample instead."), this._normalizedKeyframes = c) : this._normalizedKeyframes = new d(c), this._keyframes = c, this.activeDuration = a1.calculateActiveDuration(this._timing), this._id = f, this;
        }, b.KeyframeEffect.prototype = {
            getFrames: function() {
                return "function" == typeof this._normalizedKeyframes ? this._normalizedKeyframes : this._normalizedKeyframes._frames;
            },
            set onsample (a){
                if ("function" == typeof this.getFrames()) throw new Error("Setting onsample on custom effect KeyframeEffect is not supported.");
                this._onsample = a, this._animation && this._animation._rebuildUnderlyingAnimation();
            },
            get parent () {
                return this._parent;
            },
            clone: function() {
                if ("function" == typeof this.getFrames()) throw new Error("Cloning custom effects is not supported.");
                var b = new KeyframeEffect(this.target, [], a1.cloneTimingInput(this._timingInput), this._id);
                return b._normalizedKeyframes = this._normalizedKeyframes, b._keyframes = this._keyframes, b;
            },
            remove: function() {
                b.removeMulti([
                    this
                ]);
            }
        };
        var g = Element.prototype.animate;
        Element.prototype.animate = function(a1, c) {
            var d = "";
            return c && c.id && (d = c.id), b.timeline._play(new b.KeyframeEffect(this, a1, c, d));
        };
        var h = document.createElementNS("http://www.w3.org/1999/xhtml", "div");
        b.newUnderlyingAnimationForKeyframeEffect = function(a1) {
            if (a1) {
                var b = a1.target || h, c = a1._keyframes;
                "function" == typeof c && (c = []);
                var d = a1._timingInput;
                d.id = a1._id;
            } else var b = h, c = [], d = 0;
            return g.apply(b, [
                c,
                d
            ]);
        }, b.bindAnimationForKeyframeEffect = function(a1) {
            a1.effect && "function" == typeof a1.effect._normalizedKeyframes && b.bindAnimationForCustomEffect(a1);
        };
        var i = [];
        b.awaitStartTime = function(a1) {
            null === a1.startTime && a1._isGroup && (0 == i.length && requestAnimationFrame(e), i.push(a1));
        };
        var j = window.getComputedStyle;
        Object.defineProperty(window, "getComputedStyle", {
            configurable: !0,
            enumerable: !0,
            value: function() {
                b.timeline._updateAnimationsPromises();
                var a1 = j.apply(this, arguments);
                return e() && (a1 = j.apply(this, arguments)), b.timeline._updateAnimationsPromises(), a1;
            }
        }), window.KeyframeEffect = b.KeyframeEffect, window.Element.prototype.getAnimations = function() {
            return document.timeline.getAnimations().filter((function(a1) {
                return null !== a1.effect && a1.effect.target == this;
            }).bind(this));
        };
    }(a1, c), function(a1, b, c) {
        function d(a1) {
            a1._registered || (a1._registered = !0, g.push(a1), h || (h = !0, requestAnimationFrame(e)));
        }
        function e(a1) {
            var b = g;
            g = [], b.sort(function(a1, b) {
                return a1._sequenceNumber - b._sequenceNumber;
            }), b = b.filter(function(a1) {
                a1();
                var b = a1._animation ? a1._animation.playState : "idle";
                return "running" != b && "pending" != b && (a1._registered = !1), a1._registered;
            }), g.push.apply(g, b), g.length ? (h = !0, requestAnimationFrame(e)) : h = !1;
        }
        var f = (document.createElementNS("http://www.w3.org/1999/xhtml", "div"), 0);
        b.bindAnimationForCustomEffect = function(b) {
            var c, e = b.effect.target, g = "function" == typeof b.effect.getFrames();
            c = g ? b.effect.getFrames() : b.effect._onsample;
            var h = b.effect.timing, i = null;
            h = a1.normalizeTimingInput(h);
            var j = function() {
                var d = j._animation ? j._animation.currentTime : null;
                null !== d && (d = a1.calculateIterationProgress(a1.calculateActiveDuration(h), d, h), isNaN(d) && (d = null)), d !== i && (g ? c(d, e, b.effect) : c(d, b.effect, b.effect._animation)), i = d;
            };
            j._animation = b, j._registered = !1, j._sequenceNumber = f++, b._callback = j, d(j);
        };
        var g = [], h = !1;
        b.Animation.prototype._register = function() {
            this._callback && d(this._callback);
        };
    }(a1, c), function(a1, b, c) {
        function d(a1) {
            return a1._timing.delay + a1.activeDuration + a1._timing.endDelay;
        }
        function e(b, c, d) {
            this._id = d, this._parent = null, this.children = b || [], this._reparent(this.children), c = a1.numericTimingToObject(c), this._timingInput = a1.cloneTimingInput(c), this._timing = a1.normalizeTimingInput(c, !0), this.timing = a1.makeTiming(c, !0, this), this.timing._effect = this, "auto" === this._timing.duration && (this._timing.duration = this.activeDuration);
        }
        window.SequenceEffect = function() {
            e.apply(this, arguments);
        }, window.GroupEffect = function() {
            e.apply(this, arguments);
        }, e.prototype = {
            _isAncestor: function(a1) {
                for(var b = this; null !== b;){
                    if (b == a1) return !0;
                    b = b._parent;
                }
                return !1;
            },
            _rebuild: function() {
                for(var a1 = this; a1;)"auto" === a1.timing.duration && (a1._timing.duration = a1.activeDuration), a1 = a1._parent;
                this._animation && this._animation._rebuildUnderlyingAnimation();
            },
            _reparent: function(a1) {
                b.removeMulti(a1);
                for(var c = 0; c < a1.length; c++)a1[c]._parent = this;
            },
            _putChild: function(a1, b) {
                for(var c = b ? "Cannot append an ancestor or self" : "Cannot prepend an ancestor or self", d = 0; d < a1.length; d++)if (this._isAncestor(a1[d])) throw {
                    type: DOMException.HIERARCHY_REQUEST_ERR,
                    name: "HierarchyRequestError",
                    message: c
                };
                for(var d = 0; d < a1.length; d++)b ? this.children.push(a1[d]) : this.children.unshift(a1[d]);
                this._reparent(a1), this._rebuild();
            },
            append: function() {
                this._putChild(arguments, !0);
            },
            prepend: function() {
                this._putChild(arguments, !1);
            },
            get parent () {
                return this._parent;
            },
            get firstChild () {
                return this.children.length ? this.children[0] : null;
            },
            get lastChild () {
                return this.children.length ? this.children[this.children.length - 1] : null;
            },
            clone: function() {
                for(var b = a1.cloneTimingInput(this._timingInput), c = [], d = 0; d < this.children.length; d++)c.push(this.children[d].clone());
                return this instanceof GroupEffect ? new GroupEffect(c, b) : new SequenceEffect(c, b);
            },
            remove: function() {
                b.removeMulti([
                    this
                ]);
            }
        }, window.SequenceEffect.prototype = Object.create(e.prototype), Object.defineProperty(window.SequenceEffect.prototype, "activeDuration", {
            get: function() {
                var a1 = 0;
                return this.children.forEach(function(b) {
                    a1 += d(b);
                }), Math.max(a1, 0);
            }
        }), window.GroupEffect.prototype = Object.create(e.prototype), Object.defineProperty(window.GroupEffect.prototype, "activeDuration", {
            get: function() {
                var a1 = 0;
                return this.children.forEach(function(b) {
                    a1 = Math.max(a1, d(b));
                }), a1;
            }
        }), b.newUnderlyingAnimationForGroup = function(c) {
            var d, e = null, f = function(b) {
                var c = d._wrapper;
                if (c && "pending" != c.playState && c.effect) return null == b ? void c._removeChildAnimations() : 0 == b && c.playbackRate < 0 && (e || (e = a1.normalizeTimingInput(c.effect.timing)), b = a1.calculateIterationProgress(a1.calculateActiveDuration(e), -1, e), isNaN(b) || null == b) ? (c._forEachChild(function(a1) {
                    a1.currentTime = -1;
                }), void c._removeChildAnimations()) : void 0;
            }, g = new KeyframeEffect(null, [], c._timing, c._id);
            return g.onsample = f, d = b.timeline._play(g);
        }, b.bindAnimationForGroup = function(a1) {
            a1._animation._wrapper = a1, a1._isGroup = !0, b.awaitStartTime(a1), a1._constructChildAnimations(), a1._setExternalAnimation(a1);
        }, b.groupChildDuration = d;
    }(a1, c);
}();

//# sourceMappingURL=web-app.cd5fecdf.js.map
